module.exports = __webpack_public_path__ + "static/media/notification-on-fire.3f5c7623.svg";